/**
 * Refid1 suffix tags appended on lead-flow error redirects.
 * Extend this map as new tracking suffixes are introduced.
 */
export const LP_FAIL_SUFFIX = {
    shar: '_lp_shar_fail',
    reg: '_lp_reg_fail',
};
